<template>
	<div class="contact">
		<div class="item">
			<div class="info">{{nameError}}</div>
			<input type="text" class="item-name" placeholder="Name" v-model="nameTxt"/>
		</div>
		<div class="item">
			<div class="info">{{emailError}}</div>
			<input type="text" class="item-email" placeholder="Email" @blur="emailBlur()" v-model="emailTxt"/>
		</div>
		<div class="item">
			<div class="info">{{phoneError}}</div>
			<input type="text" class="item-phone" placeholder="Phone" v-model="phoneTxt"/>
		</div>
		<div class="item">
			<input type="text" class="item-area" placeholder="Area" v-model="areaTxt"/>
		</div>
		<div class="item">
			<textarea class="item-content" placeholder="Content" v-model="contentTxt">
				
			</textarea>
		</div>
		<div class="send-item">
			<span class="send-btn" @click="submit">SUBMIT MESSAGE</span>
		</div>

		<div class="tip-bg" :class="{hide:ishide}">
			<div class="tip-area">
				{{tipinfo}}
			</div>
		</div>

	</div>
</template>

<script>
import axios from 'axios';
export default{
	name:'Contact',
	data(){
		return {
			emailTxt:'', //邮件表单内容
			emailError:'', //邮件错误提示
			nameTxt:'', //姓名表单内容
			nameError:'', //姓名错误提示
			phoneTxt:'', //手机表单内容
			phoneError:'', //手机错误提示
			areaTxt:'', //地区表单内容
			contentTxt:'', //留言内容
			isError:false, //控制是否有错误
			ishide:true,  //控制是否隐藏
			tipinfo:'' //提示信息
		}
	},
	methods:{
		emailBlur(){
			var regEmail=/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

			if(this.emailTxt!=''){
				if(!regEmail.test(this.emailTxt)){
					this.emailError='Incorrect Email';
					this.isError=true;
					return;
				}
				this.emailError='';
				this.isError=false;
			}
			
		},
		submit(){

			this.tipinfo='Sending';
			this.ishide=false;

			if(this.emailTxt=='' && this.nameTxt=='' && this.phoneTxt=='' && this.areaTxt=='' && this.contentTxt==''){
				this.ishide=false;
				this.tipinfo='Your submission is empty';
				var _this=this;
				setTimeout(function(){
					_this.ishide=true;
					_this.tipinfo='';
				},2000)
				return false;
			}

			if(!this.isError){

				var content='';
				content+='<p>姓名：'+this.nameTxt+'</p>';
				content+='<p>邮箱：'+this.emailTxt+'</p>';
				content+='<p>手机号码：'+this.phoneTxt+'</p>';
				content+='<p>地区：'+this.areaTxt+'</p>';
				content+='<p>反馈内容：'+this.contentTxt+'</p>';
				var _this=this;
				axios.get('/api/SendEMail',{params:{account:'project-20@sresky.com',title:'来自集中器APP的信息反馈',content:content}})
				.then(function(res){
					console.log(res);
					_this.ishide=false;
					_this.tipinfo='Submitted successfully';
					setTimeout(function(){
						_this.ishide=true;
						window.location.href="/ContactUs/index";
					},2000)
				}).catch(function(err){
					console.log(err)
					_this.ishide=false;
					_this.tipinfo='Failed to send';
					setTimeout(function(){
						_this.ishide=true;
					},2000)
				})
			}
		}
	}
}
</script>

<style scoped>
.hide{
	display:none;
}
.contact{
	position:absolute;
	left:0;
	right:0;
	bottom:0;
	top:0;
	overflow:auto;
	padding-top:40px;
}
.item{
	padding:0 40px;
	margin:40px 0;
	position:relative;
}
.item input{
	outline:none;
	width:100%;
	height:50px;
	line-height:50px;
	text-indent:5px;
	border:none;
	border-bottom:1px solid #ccc;
	background:#fff;
	font-size:16px;
}
.item input:focus{
	border-color:#0DBF63;
}
.item-content{
	width:100%;
	height:200px;
	outline:none;
	border:1px solid #ccc;
	font-size:16px;
	font-family:Arial;
	resize:none;
	margin-top:20px;
}
.item-content:focus{
	border:1px solid #0DBF63;
}
.send-item{
	padding:0 40px;
}
.send-btn{
	width:100%;
	padding:10px 0;
	background:#0DBF63;
	line-height:50px;
	text-align:center;
	font-size:24px;
	color:#fff;
	display:block;
	cursor:pointer;
}
.info{
	font-size:14px;
	color:#f00;
	position:absolute;
	right:40px;
}
/*信息提示*/
.tip-bg{
	position:absolute;
	left:0;
	top:0;
	right:0;
	bottom:0;
	background:rgba(0,0,0,.5);
}
.tip-area{
	width:64%;
	height:150px;
	background:#fff;
	position:absolute;
	left:50%;
	margin-left:-32%;
	top:50%;
	margin-top:-200px;
	font-size:44px;
	padding-top:50px;
	text-align:center;
	border-radius:8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue